module.exports = __webpack_public_path__ + "media/images/LED-icon-red-ab0b18f93810bc43455e7eaa8375b314.svg";